package org.example.project.engineslot

import androidx.compose.runtime.Composable
import org.example.project.settings.AppDropdown
import org.example.project.settings.AppDropdownAppearance
import org.example.project.settings.AppDropdownMenuMode
import org.example.project.utils.All
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

@Composable
fun SlotViewLayout(
    selectedDate: String,
    selectedStandort: String,
    selectedCell: All?,
    standorte: List<All>,
    config: All,
    bookings: List<All>,
    calendarOpen: Boolean,
    editMode: Boolean,
    onDateChange: (String) -> Unit,
    onToggleCalendar: () -> Unit,
    onStandortChange: (String) -> Unit,
    onOpenSettings: () -> Unit,
    onToggleEditMode: () -> Unit,
    onToggleCellDisabled: (All) -> Unit,
    onBookingHover: (All, Double, Double) -> Unit,
    onBookingHoverEnd: () -> Unit,
    onSlotSelect: (All, All?) -> Unit,
    onSlotDoubleClick: (All, All?) -> Unit
) {
    val headline = slotStandortHeadline(standorte, selectedStandort)
    val address = slotStandortAddress(standorte, selectedStandort)
    val standortOptions = slotStandortOptions(standorte)

    SlotSharedLayout(
        headline = "",
        address = "",
        config = config,
        bookings = bookings,
        slotMode = SLOT_VIEW_OPERATIV,
        selectedDate = selectedDate,
        selectedStandort = selectedStandort,
        selectedCell = selectedCell,
        editMode = editMode,
        actionBar = {},
        topContent = {
            SlotActionBarRow(
                leftContent = {
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            alignItems(AlignItems.Center)
                            justifyContent(JustifyContent.Center)
                            gap(12.px)
                            minWidth(0.px)
                        }
                    }) {
                        SlotInlineLocation(
                            headline = headline,
                            address = address,
                            dropdown = if (standortOptions.size > 1) {
                                {
                                    Div({
                                        style {
                                            property("min-width", "max-content")
                                            maxWidth(100.percent)
                                        }
                                    }) {
                                        AppDropdown(
                                            options = standortOptions,
                                            selectedValue = selectedStandort.takeIf { it.isNotBlank() },
                                            onChange = onStandortChange,
                                            placeholder = "Adresse",
                                            appearance = AppDropdownAppearance.Underline,
                                            menuMode = AppDropdownMenuMode.Overlay
                                        )
                                    }
                                }
                            } else null
                        )
                    }
                },
                centerContent = {
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            alignItems(AlignItems.Center)
                            justifyContent(JustifyContent.Center)
                            gap(12.px)
                            minWidth(0.px)
                        }
                    }) {
                        SlotDatePager(selectedDate = selectedDate, onDateChange = onDateChange)
                    }
                },
                rightContent = {
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            alignItems(AlignItems.Center)
                            justifyContent(JustifyContent.Center)
                            gap(12.px)
                            flexWrap(FlexWrap.Wrap)
                        }
                    }) {
                        SlotToolbarAction(
                            icon = "images/kalender.svg",
                            label = "Kalender",
                            active = calendarOpen,
                            onClick = onToggleCalendar
                        )
                        SlotToolbarSeparator()
                        SlotToolbarAction(
                            icon = "images/stift.svg",
                            label = "Bearbeiten",
                            active = false,
                            onClick = onToggleEditMode
                        )
                        SlotToolbarSeparator()
                        SlotToolbarAction(
                            icon = "images/einstellungen.svg",
                            label = "Einstellungen",
                            active = false,
                            onClick = onOpenSettings
                        )
                    }
                }
            )
            if (calendarOpen) {
                SlotCalendarPopup(
                    selectedDate = selectedDate,
                    onDateChange = onDateChange,
                    onClose = onToggleCalendar
                )
            }
        },
        onCellClick = onSlotSelect,
        onCellToggleDisabled = onToggleCellDisabled,
        onBookingHover = onBookingHover,
        onBookingHoverEnd = onBookingHoverEnd,
        onCellDoubleClick = onSlotDoubleClick
    )
}
